import { Banner, Modal, TextContainer } from "@shopify/polaris";
import React from "react";

const RollbackModal = ({
  open,
  onClose,
  onConfirm,
  importHistory,
  loading,
  selectedCount,
}) => {
  if (!importHistory) return null;

  const isPartial = selectedCount && selectedCount > 0;
  const countText = isPartial
    ? `${selectedCount} selected`
    : importHistory.products_updated + importHistory.products_created;
  const title = isPartial ? "Rollback Selected Products" : "Rollback Import";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      primaryAction={{
        content: loading ? "Rolling back..." : "Confirm Rollback",
        onAction: onConfirm,
        destructive: true,
        loading: loading,
        disabled: loading,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: onClose,
          disabled: loading,
        },
      ]}
    >
      <Modal.Section>
        <TextContainer>
          <Banner
            status="warning"
            title={
              isPartial
                ? "Are you sure you want to rollback these products?"
                : "Are you sure you want to rollback this import?"
            }
          >
            <p>
              This action will revert changes for{" "}
              <strong>{countText} products</strong> from the import{" "}
              <strong>{importHistory.filename}</strong>.
            </p>
            <p>
              Products created will be deleted (or archived). Products updated
              will be reverted to their previous state.
            </p>
            <p>
              <strong>This action cannot be undone.</strong>
            </p>
          </Banner>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
};

export default RollbackModal;
